import React, { useState } from "react";
import { Link } from "react-router-dom";
// import logo from "../../assets/images/logo-all.png";
import logo2 from "../../assets/images/new-logo-2.png";

function Drawer({ drawer, action, lang }) {
  const [itemSize, setSize] = useState("0px");
  const [item, setItem] = useState("home");
  const handler = (e, value) => {
    // e.preventDefault();
    const getItems = document.querySelectorAll(`#${value} li`).length;
    if (getItems > 0) {
      setSize(`${43 * getItems}px`);
      setItem(value);
    }
  };
  return (
    <>
      {lang ? (
        <>
          <div
            onClick={(e) => action(e)}
            className={`off_canvars_overlay ${drawer ? "active" : ""}`}
          ></div>
          <div className="offcanvas_menu">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div
                    className={`offcanvas_menu_wrapper ${
                      drawer ? "active" : ""
                    }`}
                  >
                    <div className="canvas_close">
                      <a href="#" onClick={(e) => action(e)}>
                        <i className="fa fa-times"></i>
                      </a>
                    </div>
                    <div className="offcanvas-brand text-center mb-40">
                      <img src={logo2} alt="" />
                    </div>
                    <div id="menu" className="text-left ">
                      <ul className="offcanvas_main_menu">
                        <li
                          onClick={(e) => handler(e, "home")}
                          id="home"
                          className="menu-item-has-children active"
                        >
                          <span className="menu-expand">
                            <i className="fa fa-angle-down"></i>
                          </span>
                          <a href="#">أنا</a>
                          <ul
                            className="sub-menu"
                            style={{
                              height: item === "home" ? itemSize : "0px",
                            }}
                          >
                            <li>
                              <Link to="/">الصفحة الرئيسية 1</Link>
                            </li>
                            <li>
                              <Link to="/home-two">الصفحة الرئيسية 2</Link>
                            </li>
                            <li>
                              <Link to="/home-three">المنزل 3</Link>
                            </li>
                            <li>
                              <Link to="/home-four">المنزل 4</Link>
                            </li>
                            <li>
                              <Link to="/home-five">المنزل 5</Link>
                            </li>
                            <li>
                              <Link to="/home-six">الصفحة الرئيسية 6</Link>
                            </li>
                            <li>
                              <Link to="/home-seven">المنزل 7</Link>
                            </li>
                            <li>
                              <Link to="/home-eight">الصفحة الرئيسية 8</Link>
                            </li>
                            <li>
                              <Link to="/home-dark">
                                الصفحة الرئيسية الظلام
                              </Link>
                            </li>
                            <li>
                              <Link to="/home-rtl">الصفحة الرئيسية Rtl</Link>
                            </li>
                          </ul>
                        </li>
                        <li
                          onClick={(e) => handler(e, "service")}
                          id="service"
                          className="menu-item-has-children active"
                        >
                          <Link to="/service">خدمة</Link>
                        </li>
                        <li
                          onClick={(e) => handler(e, "pages")}
                          id="pages"
                          className="menu-item-has-children active"
                        >
                          <span className="menu-expand">
                            <i className="fa fa-angle-down"></i>
                          </span>
                          <a href="#">الصفحات</a>
                          <ul
                            className="sub-menu"
                            style={{
                              height: item === "pages" ? itemSize : "0px",
                            }}
                          >
                            <ul className="sub-menu">
                              <li>
                                <Link to="/about-us">عن</Link>
                              </li>
                              <li>
                                <Link to="/error">خطأ</Link>
                              </li>
                            </ul>
                          </ul>
                        </li>
                        <li
                          onClick={(e) => handler(e, "news")}
                          id="news"
                          className="menu-item-has-children active"
                        >
                          <span className="menu-expand">
                            <i className="fa fa-angle-down"></i>
                          </span>
                          <a href="#">أخبار</a>
                          <ul
                            className="sub-menu"
                            style={{
                              height: item === "news" ? itemSize : "0px",
                            }}
                          >
                            <ul className="sub-menu">
                              <li>
                                <Link to="/news">صفحة الأخبار </Link>
                              </li>
                              <li>
                                <Link to="/news/single-news">أخبار واحدة</Link>
                              </li>
                            </ul>
                          </ul>
                        </li>
                        <li
                          onClick={(e) => handler(e, "contact")}
                          id="contact"
                          className="menu-item-has-children active"
                        >
                          <Link to="/contact">اتصل</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="offcanvas-social">
                      <ul className="text-center">
                        <li>
                          <a href="$">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a href="$">
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="$">
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="$">
                            <i className="fab fa-dribbble"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="footer-widget-info">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fal fa-envelope"></i>{" "}
                            support@appie.com
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fal fa-phone"></i> +(642) 342 762 44
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fal fa-map-marker-alt"></i> 442 Belle
                            Terre St Floor 7, San Francisco, AV 4206
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            onClick={(e) => action(e)}
            className={`off_canvars_overlay ${drawer ? "active" : ""}`}
          ></div>
          <div className="offcanvas_menu">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div
                    className={`offcanvas_menu_wrapper ${
                      drawer ? "active" : ""
                    }`}
                  >
                    <div className="canvas_close">
                      <a href="/" onClick={(e) => action(e)}>
                        <i className="fa fa-times"></i>
                      </a>
                    </div>
                    <div className="offcanvas-brand text-center mb-40">
                      <img src={logo2} alt="" />
                    </div>
                    <div id="menu" className="text-left ">
                      <ul className="offcanvas_main_menu">
                        <li
                          onClick={(e) => handler(e, "home")}
                          id="home"
                          className="menu-item-has-children active"
                        >
                          <a href="/">Home</a>
                        </li>
                        <li
                          onClick={(e) => handler(e, "rules")}
                          id="rules"
                          className="menu-item-has-children active"
                        >
                          <a href="/rules">Rules</a>
                        </li>
                        <li
                          onClick={(e) => handler(e, "sports")}
                          id="sports"
                          className="menu-item-has-children active"
                        >
                          <span className="menu-expand">
                            <i className="fa fa-angle-down"></i>
                          </span>
                          <a href="#">Sports</a>
                          <ul
                            className="sub-menu"
                            style={{
                              height: item === "sports" ? itemSize : "0px",
                            }}
                          >
                            <li>
                              <Link to="/sports/football">Football</Link>
                            </li>
                            <li>
                              <Link to="/sports/turf-cricket-boys">
                                Turf Cricket (Boys)
                              </Link>
                            </li>
                            <li>
                              <Link to="/sports/turf-cricket-girls">
                                Turf Cricket (Girls)
                              </Link>
                            </li>
                            <li>
                              <Link to="/sports/volleyball">Volleyball</Link>
                            </li>
                            <li>
                              <Link to="/sports/basketball">Basketball</Link>
                            </li>
                            <li>
                              <Link to="/sports/snooker">Snooker</Link>
                            </li>
                            <li>
                              <Link to="/sports/squash">Squash</Link>
                            </li>
                            <li>
                              <Link to="/sports/lawn-tennis">Lawn Tennis</Link>
                            </li>
                            <li>
                              <Link to="/sports/table-tennis">
                                Table Tennis
                              </Link>
                            </li>
                            <li>
                              <Link to="/sports/badminton">Badminton</Link>
                            </li>
                            <li>
                              <Link to="/sports/chess">Chess</Link>
                            </li>
                            <li>
                              <Link to="/sports/carrom">Carrom</Link>
                            </li>
                            <li>
                              <Link to="/sports/swimming">Swimming</Link>
                            </li>
                            <li>
                              <Link to="/sports/sprint">Sprint</Link>
                            </li>
                            {/* <li>
                              <Link to="/sports/throw-ball">Throw Ball</Link>
                            </li> */}
                          </ul>
                        </li>
                        <li
                          onClick={(e) => handler(e, "contact")}
                          id="contact"
                          className="menu-item-has-children active"
                        >
                          <Link to="/contact">Contact</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="offcanvas-social">
                      <ul className="text-center">
                        <li>
                          <a href="https://www.instagram.com/jitoyouthpune">
                            <i className="fab fa-instagram" />
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="footer-widget-info">
                      <ul>
                        <li className="d-flex align-items-center gap-2 text-nowrap">
                          <a href="tel:+919531455771">
                            <i className="fal fa-phone mr-2" />
                            <span>Aditya Lodha: </span>
                            <span className="ml-1"> +91 95617 55771</span>
                          </a>
                        </li>
                        <li className="d-flex align-items-center gap-2 mt-3 text-nowrap">
                          <a href="tel:+919890629114">
                            <i className="fal fa-phone" />
                            <span>Ayush Palesha: </span>
                            <span className="ml-1"> +91 98906 29114</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Drawer;
